// extracted by mini-css-extract-plugin
export var enter = "HeaderMega-module--enter--YZTHE";
export var enterActive = "HeaderMega-module--enterActive--ul7VR";
export var exit = "HeaderMega-module--exit--2kJxH";
export var exitActive = "HeaderMega-module--exitActive--7axhr";